import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsAndConditionsPage } from './pages/TermsAndConditionsPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-5" />} data-id="element-4" />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage data-id="element-7" />} data-id="element-6" />
      </Routes>
    </Router>;
}